import React, { FC } from 'react';
import { Label, RadioGroup, Validation, ValidationStatus } from '@silverfort/sf-components';

interface Option {
    title: string;
    value: string;
}

interface AdUserIdentifierFieldProps {
    label?: string;
    mandatory?: boolean;
    labelClassName?: string;
    selectedOption: string;
    onChange: (value: string) => void;
    containerClassName?: string;
    options: Option[];
    errorMessage?: string;
}

const TokenRadioGroupField: FC<AdUserIdentifierFieldProps> = ({
                                                                  label = '',
                                                                  mandatory = false,
                                                                  labelClassName = 'w-[235px]',
                                                                  selectedOption,
                                                                  onChange,
                                                                  containerClassName = '',
                                                                  options,
                                                                  errorMessage
                                                              }) => {
    return (
        <div className={`flex items-center gap-2 ${containerClassName}`}>
            <Label text={label} mandatory={mandatory} className={labelClassName} />
            <div className="flex flex-col h-10">
                <RadioGroup
                    containerClassName="min-h-10 max-h-10"
                    selectedOption={selectedOption}
                    options={options}
                    // @ts-ignore Ticket: https://silverfort.atlassian.net/browse/AF-35931*/
                    onChange={(value) => onChange(value)}
                />
                {errorMessage && (
                    <Validation showIcon={false} text={errorMessage} validationStatus={ValidationStatus.Error} />
                )}
            </div>
        </div>
    );
};

export default TokenRadioGroupField;